<template>
  <div class="header">
    <div class="header__logo unselect" @click="goHome">
      <div class="logo__left">checker</div>
      <div class="logo__right">fb.rip</div>
    </div>

    <div style="display: flex; gap: 10px">
      <!-- <div
        style="display: flex; align-items: center"
        v-if="isAuth && viewUserData.tariffId === 3"
      >
        Осталось дней: {{ viewUserData.tariffExpireDays }}
      </div>
      <div style="display: flex; align-items: center" v-else-if="isAuth">
        Доступно проверок: {{ viewUserData.checks }}
      </div>
      <div
        class="vl"
        style="border-left: 2px solid #c8c8c8"
        v-if="isAuth"
      ></div> -->

      <div style="position: relative" v-if="!hideMenu" @click="openUserMenu">
        <!-- !start -->
        <div class="user-profile unselect">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            style="fill: #333"
          >
            <path
              d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"
            ></path>
          </svg>
          <span>Админ-панель</span>
        </div>
        <!-- !end -->

<!-- ! -->
        <!-- <div
          class="user-menu"
          v-if="isVisibleUserMenu"
          @mouseleave="isVisibleUserMenu = false"
        >
          <div class="user-email" @click.stop>
            {{ viewUserData.email }}
          </div>
          <div class="user-menu__items">
             <router-link to="/pay" tag="button" class="user-menu__items-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                style="fill: #333"
              >
                <path
                  d="M21 4H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-1 11a3 3 0 0 0-3 3H7a3 3 0 0 0-3-3V9a3 3 0 0 0 3-3h10a3 3 0 0 0 3 3v6z"
                ></path>
                <path
                  d="M12 8c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                ></path>
              </svg>
              Оплата
            </router-link> 

             <router-link
              to="/referral"
              tag="button"
              class="user-menu__items-item"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                style="fill: #333"
              >
                <circle cx="6" cy="4" r="2"></circle>
                <path
                  d="M9,7H3A1,1,0,0,0,2,8v7H4v7H8V15h2V8A1,1,0,0,0,9,7Z"
                ></path>
                <circle cx="17" cy="4" r="2"></circle>
                <path
                  d="M20.21,7.73a1,1,0,0,0-1-.73h-4.5a1,1,0,0,0-1,.73L12,14h2l-1,4h2v4h4V18h2l-1-4h2Z"
                ></path></svg
              >Рефералы
            </router-link> 

             <div class="user-menu__items-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                style="fill: #333"
              >
                <path
                  d="m2.344 15.271 2 3.46a1 1 0 0 0 1.366.365l1.396-.806c.58.457 1.221.832 1.895 1.112V21a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.598a8.094 8.094 0 0 0 1.895-1.112l1.396.806c.477.275 1.091.11 1.366-.365l2-3.46a1.004 1.004 0 0 0-.365-1.366l-1.372-.793a7.683 7.683 0 0 0-.002-2.224l1.372-.793c.476-.275.641-.89.365-1.366l-2-3.46a1 1 0 0 0-1.366-.365l-1.396.806A8.034 8.034 0 0 0 15 4.598V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1.598A8.094 8.094 0 0 0 7.105 5.71L5.71 4.904a.999.999 0 0 0-1.366.365l-2 3.46a1.004 1.004 0 0 0 .365 1.366l1.372.793a7.683 7.683 0 0 0 0 2.224l-1.372.793c-.476.275-.641.89-.365 1.366zM12 8c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z"
                ></path></svg
              >Настройки
            </div> 

            <div class="user-menu__items-item" @click="logout">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                style="fill: #333"
              >
                <path
                  d="M18 2H6a1 1 0 0 0-1 1v9l5-4v3h6v2h-6v3l-5-4v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"
                ></path></svg
              >Выйти
            </div>
          </div>
        </div> -->
      </div>

      <div v-if="hideMenu">
        <div
          class="support unselect"
          @click="goNews"
          v-tippy="{
            content: 'Новости',
            hideOnClick: false,
            theme: 'material',
            animation: 'shift-away',
          }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            style="fill: #333"
          >
            <path
              d="M20 17a1 1 0 0 1-2 0V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v13a2 2 0 0 0 2 2h15c1.654 0 3-1.346 3-3V7h-2v10zM12 7h3v2h-3V7zm0 4h3v2h-3v-2zM5 7h5v6H5V7zm0 10v-2h10v2H5z"
            ></path>
          </svg>
        </div>
      </div>

      <div v-if="hideMenu">
        <div
          class="support unselect"
          @click="goSupport"
          v-tippy="{
            content: 'Поддержка',
            hideOnClick: false,
            theme: 'material',
            animation: 'shift-away',
          }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            style="fill: #333"
          >
            <path
              d="M12 2C6.486 2 2 6.486 2 12v4.143C2 17.167 2.897 18 4 18h1a1 1 0 0 0 1-1v-5.143a1 1 0 0 0-1-1h-.908C4.648 6.987 7.978 4 12 4s7.352 2.987 7.908 6.857H19a1 1 0 0 0-1 1V18c0 1.103-.897 2-2 2h-2v-1h-4v3h6c2.206 0 4-1.794 4-4 1.103 0 2-.833 2-1.857V12c0-5.514-4.486-10-10-10z"
            ></path>
          </svg>
        </div>
      </div>

      <div v-if="hideMenu" @click="openLangMenu" style="position: relative">
        <div class="switch-country unselect">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
          >
            <path
              d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.931 9h-2.764a14.67 14.67 0 0 0-1.792-6.243A8.013 8.013 0 0 1 19.931 11zM12.53 4.027c1.035 1.364 2.427 3.78 2.627 6.973H9.03c.139-2.596.994-5.028 2.451-6.974.172-.01.344-.026.519-.026.179 0 .354.016.53.027zm-3.842.7C7.704 6.618 7.136 8.762 7.03 11H4.069a8.013 8.013 0 0 1 4.619-6.273zM4.069 13h2.974c.136 2.379.665 4.478 1.556 6.23A8.01 8.01 0 0 1 4.069 13zm7.381 6.973C10.049 18.275 9.222 15.896 9.041 13h6.113c-.208 2.773-1.117 5.196-2.603 6.972-.182.012-.364.028-.551.028-.186 0-.367-.016-.55-.027zm4.011-.772c.955-1.794 1.538-3.901 1.691-6.201h2.778a8.005 8.005 0 0 1-4.469 6.201z"
            ></path>
          </svg>
          <span>{{ viewUserLang }}</span>
        </div>
        <div
          v-if="isVisibleLangMenu"
          @mouseleave="isVisibleLangMenu = false"
          class="lang-menu"
        >
          <span
            class="lang-menu-item"
            v-for="item in sortLangs()"
            :key="item.shortName"
            @click="changeUserLang(item.shortName)"
            :class="{ current: item.shortName === currentUserLang }"
          >
            <span>{{ item.nativeName }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { directive } from 'vue-tippy';

export default {
  directives: {
    tippy: directive,
  },
  data() {
    return {
      isVisibleUserMenu: false,
      isVisibleLangMenu: false,
      // userEmail: this.$store.state.user.email,
      // nickname: this.$store.state.nickname,
      currentUserLang: localStorage.userLang,
      langs: [
        {
          shortName: 'de',
          iso: 'German',
          nativeName: 'Deutsch',
        },
        {
          shortName: 'en',
          iso: 'English',
          nativeName: 'English',
        },
        {
          shortName: 'es',
          iso: 'Spanish',
          nativeName: 'Español',
        },
        {
          shortName: 'fr',
          iso: 'French',
          nativeName: 'Français',
        },
        {
          shortName: 'it',
          iso: 'Italian',
          nativeName: 'Italiano',
        },
        {
          shortName: 'pt',
          iso: 'Portuguese',
          nativeName: 'Português',
        },
        {
          shortName: 'ru',
          iso: 'Russian',
          nativeName: 'Русский',
        },

        {
          shortName: 'tr',
          iso: 'Turkish',
          nativeName: 'Türkçe',
        },
        {
          shortName: 'zh',
          iso: 'Chinese',
          nativeName: '中文',
        },
        {
          shortName: 'uk',
          iso: 'Ukrainian',
          nativeName: 'Українська',
        },
      ],
    };
  },

  computed: {

    hideMenu() {
      return this.$route.name !== 'Dashboard' &&
        this.$route.name !== 'DashboardChecks' &&
        this.$route.name !== 'DashboardDonors' &&
        this.$route.name !== 'DashboardImport' &&
        this.$route.name !== 'DashboardSettings' &&
        this.$route.name !== 'DashboardLogin' &&
        this.$route.name !== 'DashboardDonor' &&
        this.$route.name !== 'DashboardProxy'
        ? true
        : false;
    },

    ...mapGetters(['isLoggedIn', 'userInfo']),

    isAuth() {
      return this.isLoggedIn;
    },

    viewUserLang() {
      if (this.$i18n.availableLocales.includes(this.currentUserLang)) {
        return this.langs.filter((l) => l.shortName === this.currentUserLang)[0]
          .nativeName;
      } else {
        return this.langs.filter((l) => l.shortName === 'en')[0].nativeName;
      }
    },

    viewUserData() {
      // console.log(this.userInfo);
      if (this.userInfo.length && this.isLoggedIn) {
        return this.userInfo;
      } else {
        return JSON.parse(localStorage.userInfo);
      }
    },
  },

  methods: {
    goHome() {
      window.open('/');
    },

    goSupport() {
      window.open('https://t.me/bioshok333');
    },

    goNews() {
      window.open('https://t.me/s/checkerFBRIP');
    },

    openUserMenu() {
      this.isVisibleUserMenu = !this.isVisibleUserMenu;
      this.isVisibleLangMenu = false;
    },

    openLangMenu() {
      this.isVisibleLangMenu = !this.isVisibleLangMenu;
      this.isVisibleUserMenu = false;
    },

    changeUserLang(lang) {
      // console.log(this.$i18n);

      this.currentUserLang = lang;
      localStorage.userLang = lang;
      this.$i18n.locale = lang;
      document.querySelector('html').setAttribute('lang', lang);
    },

    sortLangs() {
      return this.langs.sort((a, b) => a.shortName.localeCompare(b.shortName));
    },

    // Подгружаем актуальные данные по пользователю
    // async getUserInfo() {
    //   if (this.isLoggedIn) {
    //     // await this.$store.dispatch('updateUserInfo');

    //     this.axios.get('user/me').then((resp) => {
    //       this.$store.state.user = resp.data.user;
    //       localStorage.userInfo = JSON.stringify(resp.data.user);
    //     });
    //   }
    // },

    async logout() {
      const isConfirm = confirm(
        `Вы точно хотите выйти из аккаунта ${
          JSON.parse(localStorage.userInfo).email
        }?`
      );

      if (isConfirm) {
        await this.$store.dispatch('logout');
        this.$router.push('/login');
      }
    },
  },

  mounted() {
    // this.getUserInfo();

    // Устанавливаем язык пользователя в localStorage, если его нет
    if (!localStorage.userLang) {
      const userLang = navigator.language.slice(0, 2);
      localStorage.userLang = userLang;
      this.currentUserLang = userLang;
      document.querySelector('html').setAttribute('lang', userLang);
    }

    if (this.$i18n.availableLocales.includes(localStorage.userLang)) {
      this.$i18n.locale = localStorage.userLang;
      document
        .querySelector('html')
        .setAttribute('lang', localStorage.userLang);
    } else {
      this.$i18n.locale = 'en';
      document.querySelector('html').setAttribute('lang', 'en');
    }
  },
};
</script>

<style scoped>
.user-profile,
.support {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 2px 5px 2px 5px;
  gap: 5px;
  border: 2px solid #333;
  border-radius: 5px;
  box-shadow: rgb(189 186 186) 0px 5px 20px -6px;
  transition: all 0.2s;
  transition-timing-function: ease-in;
}

.user-profile:hover,
.support:hover {
  /* background: #eeeded; */
  /* border-color: #28a0a0 !important; */
  box-shadow: none;
}

.user-profile > span {
  color: #333;
}

.user-menu {
  position: absolute;
  margin: 5px 0 0 0;
  padding: 5px 0;
  right: 0;
  min-width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%);
  border-radius: 5px;
  z-index: 9999;
}

.user-email {
  padding: 5px 10px;
  background: #02769d;
  color: white;
}

.user-menu__items {
  margin: 5px 0 0 0;
  /* padding: 5px 0; */
  cursor: pointer;
}

.user-menu__items-item {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  color: inherit;
  /* border-radius: 5px; */
}

.user-menu__items-item:hover {
  background: #eeeded;
}

.user-menu__items-item.current {
  background: #5a5a5a;
  color: white;
}

.lang-menu {
  display: flex;
  flex-direction: column;
  /* gap: 5px; */
  position: absolute;
  /* list-style: none; */
  margin: 5px 0 0 0;
  padding: 5px 0;
  right: 0;
  min-width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%);
  border-radius: 5px;
  /* column-count: 2;
  column-gap: 0; */
  z-index: 9999;
}

.lang-menu-item {
  padding: 5px 15px;
  cursor: pointer;
  /* border-radius: 5px; */
}

.lang-menu-item:hover {
  background: #eeeded;
  /* color: white; */
}

.lang-menu-item.current {
  background: #5a5a5a;
  color: white;
}
</style>